<!-- ── HP Top Bar ─────────────────────────────────────────────────── -->
<div
  class="flex-shrink-0 flex items-center h-11 px-4 gap-4 bg-hp-panel text-hp-ink relative z-[100]"
  style="border-bottom: 1px solid var(--hp-hair)"
>
  <!-- Brand -->
  <div class="flex items-center gap-2.5 select-none">
    <img
      src="assets/logo-avatar.jpg"
      alt="Naviqore"
      class="shrink-0 object-contain rounded-md"
      style="height: 24px; width: auto"
    />
    <div
      class="text-[11.5px] font-semibold tracking-[0.2px] font-hp-sans leading-none"
    >
      NAVIQORE
    </div>
  </div>

  <div class="w-px h-5 mx-1 shrink-0" style="background: var(--hp-hair)"></div>

  <!-- Nav tabs -->
  <nav class="flex h-full">
    @for (tab of navTabs; track tab.label) {
      <span
        class="relative flex items-center px-3 text-[10.5px] font-semibold tracking-[1px] cursor-pointer font-hp-sans transition-colors"
        [class.text-hp-accent]="tab.active"
        [class.text-hp-muted]="!tab.active"
        (click)="goToMap()"
      >
        {{ tab.label }}
        @if (tab.active) {
          <span class="absolute inset-x-3 bottom-0 h-0.5 bg-hp-accent"></span>
        }
      </span>
    }

    <!-- Tools dropdown — inside nav so spacing is identical to other tabs -->
    @if ($toolbuttons | async; as toolGroups) {
      <div class="relative flex h-full" (click)="$event.stopPropagation()">
        <span
          class="relative flex items-center gap-1 px-3 text-[10.5px] font-semibold tracking-[1px] cursor-pointer font-hp-sans transition-colors select-none"
          [class.text-hp-accent]="toolsOpen || isToolsPage"
          [class.text-hp-muted]="!toolsOpen && !isToolsPage"
          (click)="toolsOpen = !toolsOpen"
        >
          TOOLS
          <svg
            viewBox="0 0 24 24"
            width="9"
            height="9"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            style="
              flex-shrink: 0;
              margin-top: 1px;
              transition: transform 120ms ease;
            "
            [style.transform]="toolsOpen ? 'rotate(180deg)' : 'rotate(0deg)'"
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
          @if (toolsOpen || isToolsPage) {
            <span class="absolute inset-x-3 bottom-0 h-0.5 bg-hp-accent"></span>
          }
        </span>

        @if (toolsOpen) {
          <div
            class="absolute top-full left-0 mt-1 z-[300] flex flex-col rounded-[10px] bg-hp-panel border border-black/[0.12] shadow-[0_8px_28px_rgba(20,18,14,0.10),0_2px_8px_rgba(20,18,14,0.06)]"
            style="width: 680px"
            (click)="$event.stopPropagation()"
          >
            <!-- Header -->
            <div
              class="flex items-center justify-between px-4 py-2.5 border-b border-black/[0.08] shrink-0"
            >
              <span
                class="font-hp-sans text-[10px] font-semibold tracking-[0.9px] uppercase text-hp-muted"
                >Tools</span
              >
              <button
                class="flex items-center justify-center w-[22px] h-[22px] rounded-[5px] border border-black/10 bg-transparent text-hp-muted cursor-pointer hover:bg-hp-panel-deep hover:text-hp-ink transition-colors p-0"
                (click)="toolsOpen = false"
                aria-label="Close"
              >
                <svg
                  viewBox="0 0 24 24"
                  width="11"
                  height="11"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>
            <!-- 4-col grid -->
            <div class="grid grid-cols-4 gap-1.5 p-3">
              @for (btn of toolGroups[0]; track btn.id) {
                @if (!btn.hide) {
                  <button
                    class="group flex flex-col items-start gap-2.5 p-3 rounded-[8px] border border-transparent bg-transparent text-left cursor-pointer hover:bg-hp-panel-deep hover:border-black/[0.08] transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
                    [disabled]="btn.disabled"
                    (click)="onToolClick(btn)"
                  >
                    <span
                      class="flex items-center justify-center w-8 h-8 rounded-[7px] bg-hp-panel-deep text-hp-ink2 group-hover:bg-hp-accent-soft group-hover:text-hp-accent transition-colors"
                      [innerHTML]="toolIcon(btn.id)"
                    ></span>
                    <span
                      class="text-[11px] font-medium text-hp-ink2 leading-tight font-hp-sans tracking-[0.2px]"
                    >
                      {{ btn.tooltip }}
                    </span>
                  </button>
                }
              }
            </div>
          </div>
        }
      </div>
    }
  </nav>

  <div class="flex-1"></div>

  <!-- Right controls -->
  <div class="flex items-center gap-3">
    @if ($VesselsHasError | async) {
      <span
        class="relative flex h-2 w-2"
        hpTooltip="One or more vessels are reporting data errors"
        hpTooltipPlacement="bottom"
      >
        <span
          class="animate-ping absolute inline-flex h-full w-full rounded-full bg-hp-crit opacity-60"
        ></span>
        <span
          class="relative inline-flex h-2 w-2 rounded-full bg-hp-crit"
        ></span>
      </span>
    }
    @if (tzDisplay$ | async; as tz) {
      <div
        class="font-hp-sans text-[10.5px] text-hp-ink2 tracking-[0.4px] tabular-nums"
      >
        {{ tz.now | date: "dd'·'MMM'·'yyyy" : tz.offsetStr }}
        <span class="text-hp-muted">·</span>
        <span class="text-hp-accent"
          >{{ tz.now | date: 'HH:mm:ss' : tz.offsetStr }} {{ tz.label }}</span
        >
      </div>
    }
    <app-hp-timezone-picker />

    <!-- Theme toggle -->
    <button
      class="relative flex items-center justify-center w-[30px] h-[30px] rounded-[8px] border border-black/[0.10] bg-transparent hover:bg-hp-panel-deep transition-colors overflow-hidden"
      (click)="toggleTheme()"
      [title]="
        (isDark$ | async) ? 'Switch to light mode' : 'Switch to dark mode'
      "
      style="flex-shrink: 0"
    >
      <!-- Moon (dark mode active → click to go light) -->
      <svg
        viewBox="0 0 24 24"
        width="14"
        height="14"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="text-hp-ink absolute transition-all"
        [style.opacity]="(isDark$ | async) ? '1' : '0'"
        [style.transform]="
          (isDark$ | async)
            ? 'rotate(0deg) scale(1)'
            : 'rotate(-90deg) scale(0.5)'
        "
        style="
          transition:
            opacity 300ms cubic-bezier(0.34, 1.56, 0.64, 1),
            transform 300ms cubic-bezier(0.34, 1.56, 0.64, 1);
        "
      >
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
      </svg>
      <!-- Sun (light mode active → click to go dark) -->
      <svg
        viewBox="0 0 24 24"
        width="14"
        height="14"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="text-hp-ink absolute transition-all"
        [style.opacity]="(isDark$ | async) ? '0' : '1'"
        [style.transform]="
          (isDark$ | async)
            ? 'rotate(90deg) scale(0.5)'
            : 'rotate(0deg) scale(1)'
        "
        style="
          transition:
            opacity 300ms cubic-bezier(0.34, 1.56, 0.64, 1),
            transform 300ms cubic-bezier(0.34, 1.56, 0.64, 1);
        "
      >
        <circle cx="12" cy="12" r="5" />
        <line x1="12" y1="1" x2="12" y2="3" />
        <line x1="12" y1="21" x2="12" y2="23" />
        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
        <line x1="1" y1="12" x2="3" y2="12" />
        <line x1="21" y1="12" x2="23" y2="12" />
        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
      </svg>
    </button>

    <div class="w-px h-4 shrink-0" style="background: var(--hp-hair)"></div>
    <app-user-menu />
  </div>
</div>

<!-- ── Main body ───────────────────────────────────────────────────── -->
@if ({ active: activeVessel$ | async, rightBar: rightBar$ | async }; as obs) {
  <div
    class="flex-1 relative overflow-hidden bg-hp-paper"
    [style.--dashboard-right-panel-width]="
      obs.rightBar === 'routeOptimazation'
        ? '420px'
        : obs.rightBar === 'vesselSearch'
          ? '320px'
          : '0px'
    "
  >
    <!-- Map: always full-size, never reflows when sidebars open/close -->
    <div class="absolute inset-0 z-0">
      <app-dashboard-map />
    </div>

    <!-- Bottom timeline (floating, centered in full map area) -->
    @if (!isToolsPage) {
      @if ({ data: $timezoneData | async }; as tz) {
        <div
          class="absolute bottom-4 left-1/2 -translate-x-1/2 z-10 flex items-center gap-4 pointer-events-auto z-50"
        >
          <app-map-timeline-v2
            [timezone]="tz.data.tzOffset"
            [timezonePreview]="tz.data.tzPreview"
            [mode]="obs.active"
            [dateFrom]="$DateFrom | async"
            [dateTo]="$DateTo | async"
            (dateChanged)="selectNewDate($event)"
            (stepSizeChanged)="setStepSize($event)"
            (toDateRealTimeChanged)="setToDateInterval($event)"
          />
        </div>
      }
    }

    <app-copyright />

    <!-- Left overlay (vessel sidebar) or full-screen overlay (tools pages) -->
    <div
      class="absolute pointer-events-auto"
      [class]="
        isToolsPage ? 'inset-0 z-30 bg-hp-paper' : 'top-0 left-0 bottom-0 z-20'
      "
    >
      <router-outlet></router-outlet>
    </div>

    <!-- Right overlay: keeps map controls beside the open right panel -->
    @if ({ rightBar: rightBar$ | async }; as panelObs) {
      <div
        class="absolute top-0 right-0 bottom-0 z-20 flex items-start pointer-events-none"
      >
        <div class="mt-1 mr-1 flex flex-col gap-1.5 pointer-events-auto">
          @if (
            panelObs.rightBar !== 'vesselSearch' &&
            panelObs.rightBar !== 'routeOptimazation'
          ) {
            <button
              class="flex items-center justify-center w-7 h-7 rounded-[8px] bg-hp-panel text-hp-muted2 hover:text-hp-ink hover:bg-hp-panel-deep transition-colors shadow-sm"
              style="border: 1px solid var(--hp-hair)"
              (click)="openList()"
              title="Fleet"
            >
              <svg
                viewBox="0 0 24 24"
                width="13"
                height="13"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <line x1="8" y1="6" x2="21" y2="6" />
                <line x1="8" y1="12" x2="21" y2="12" />
                <line x1="8" y1="18" x2="21" y2="18" />
                <line x1="3" y1="6" x2="3.01" y2="6" />
                <line x1="3" y1="12" x2="3.01" y2="12" />
                <line x1="3" y1="18" x2="3.01" y2="18" />
              </svg>
            </button>
          }
          @if (!isInfoPage) {
            <app-map-control
              direction="column-reverse"
              tooltipPlacement="left"
              tooltipTitle="Map Layers"
              icon="layers"
              [buttons]="$mapLayerControls | async"
              (selectedOption)="mapButtonSelectHandler($event)"
            />
            <app-map-zoom-level [zoom]="helper.zoom$ | async" />
          }
          <app-full-screen-button />
        </div>

        @if (panelObs.rightBar === 'routeOptimazation') {
          <!-- Course Planning panel -->
          <div
            class="flex flex-col h-full overflow-hidden pointer-events-auto"
            style="width: var(--dashboard-right-panel-width)"
          >
            <app-course-planning-wrapper
              [vesselLatLngCb]="vesseLatLng"
              class="h-full"
            />
          </div>
        } @else if (panelObs.rightBar === 'vesselSearch') {
          <!-- Fleet panel -->
          <div
            class="flex flex-col h-full bg-hp-panel overflow-hidden pointer-events-auto"
            style="
              border-left: 1px solid var(--hp-hair);
              width: var(--dashboard-right-panel-width);
            "
          >
            <div
              class="flex items-center justify-between px-3 h-9 shrink-0"
              style="border-bottom: 1px solid var(--hp-hair)"
            >
              <div class="flex items-center gap-2">
                <span
                  class="font-hp-sans text-[9.5px] font-semibold tracking-[1px] uppercase text-hp-muted"
                  >Fleet</span
                >
                <span
                  class="font-hp-sans text-[9.5px] text-hp-muted2 tracking-[0.4px]"
                >
                  {{ $vesselCount | async }}
                  <span class="opacity-60">SHIPS</span>
                </span>
              </div>
              <button
                class="flex items-center justify-center w-[22px] h-[22px] rounded-[5px] text-hp-muted hover:bg-hp-panel-deep hover:text-hp-ink transition-colors"
                style="border: 1px solid var(--hp-hair)"
                (click)="closeList()"
                title="Collapse"
              >
                <svg
                  viewBox="0 0 24 24"
                  width="10"
                  height="10"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="9 18 15 12 9 6" />
                </svg>
              </button>
            </div>
            <div class="flex-1 overflow-hidden min-h-0">
              <app-vessel-list-wrapper class="pointer-events-auto h-full" />
            </div>
            @if (obs.active === 'both') {
              <div
                class="shrink-0 p-3"
                style="border-top: 1px solid var(--hp-hair)"
              >
                <app-trace-overview
                  [isLoading]="TraceLoading$ | async"
                  (selectTrace)="selectTrace($event)"
                  [ActiveTrace$]="ActiveTrace$"
                  [TraceConfig$]="TraceConfig$"
                />
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
